import { useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useUserPermissions } from "@/hooks/use-user-permissions";
import { syncPostHogUser } from "@/lib/posthog";

/** Waits for the session and the permissions, so an agency user is never captured, even briefly. */
export function PostHogIdentity() {
  const { user, loading } = useAuth();
  const { agenciaId, screens, isLoading, isError } = useUserPermissions();
  const userId = user?.id;
  const isInternal = !agenciaId && !isError && screens.length > 0;

  useEffect(() => {
    if (loading) return;
    if (!userId) {
      syncPostHogUser(null);
      return;
    }
    if (isLoading) return;
    syncPostHogUser({ id: userId, isInternal });
  }, [loading, userId, isLoading, isInternal]);

  return null;
}
